import { render, staticRenderFns } from "./ocPayment.vue?vue&type=template&id=067d5510&"
import script from "./ocPayment.vue?vue&type=script&lang=js&"
export * from "./ocPayment.vue?vue&type=script&lang=js&"
import style0 from "./ocPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('067d5510')) {
      api.createRecord('067d5510', component.options)
    } else {
      api.reload('067d5510', component.options)
    }
    module.hot.accept("./ocPayment.vue?vue&type=template&id=067d5510&", function () {
      api.rerender('067d5510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/ocPayment.vue"
export default component.exports